module.exports = {"$id":"creator.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","required":["name","version"],"properties":{"name":{"type":"string"},"version":{"type":"string"},"comment":{"type":"string"}}}


//////////////////
// WEBPACK FOOTER
// ./~/har-schema/lib/creator.json
// module id = 2459
// module chunks = 1